import type { Attachment } from 'svelte/attachments'

// Svelte attachment for dynamic inline styles: `<div {@attach inlineStyle(`width: var(${token})`)}>`. A `style`
// attribute is rendered into the server-side HTML, where the Content Security Policy blocks it. An attachment runs
// only in the browser, and styles set through the CSSOM (`element.style`) are allowed.
export function inlineStyle(style: string): Attachment<HTMLElement> {
  return (element) => {
    element.style.cssText = style
  }
}
